module.exports = __webpack_public_path__ + "images/videoCaseStudy-mandel-challenge-float01.jpg?h=57e2bf087ce8069116cdfeef0b1e1ee9";


//////////////////
// WEBPACK FOOTER
// ./src/theme/images/videoCaseStudies/mandel/videoCaseStudy-mandel-challenge-float01.jpg
// module id = 2103
// module chunks = 12 15